/* RESPONSIBLE TEAM: team-ai-agent */
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import IntercomRoute from 'embercom/routes/base/intercom-route';

export default class FinAIAgentTeammateConsultationRoute extends IntercomRoute {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  analytics = {
    section: 'ai-chatbot',
    place: 'teammate-consultation',
  };

  get titleToken(): string {
    return this.intl.t('ai-agent.teammate-consultation.page-title');
  }

  async model() {
    return {};
  }
}
